import React, { useState, useEffect } from 'react';
import { Popover } from 'antd';
import moment, { Moment } from 'moment';
import { Row, Col, Button } from 'antd';
import { RightOutlined, LeftOutlined, FileExcelOutlined } from '@ant-design/icons';
import './index.scss';

export interface HeaderProps {
  currentMonth: Moment;
  prevMonth: () => void;
  nextMonth: () => void; 
}
const RenderHeader = ({ currentMonth, prevMonth, nextMonth }:HeaderProps) => {
  return (
      <div className="header row">
          <div className="col col-end">
            <LeftOutlined onClick={prevMonth} />  
          </div>        
          <div className="col col-start">
              <span className="text">
                  {moment(currentMonth).format('YYYY년 M월')}
              </span>
          </div>
          <div className="col col-end">
            <RightOutlined onClick={nextMonth}/>   
          </div>
      </div>
  );
};


const RenderDays = () => {
  const days:any[] = [];
  const date = ['일', '월', '화', '수', '목', '금', '토'];
  const celWidth = ['14%', '14.4%', '14.4%', '14%.4', '14%.4', '14%.4', '14%'];

  for (let i = 0; i < 7; i++) {
      days.push(
          <Col className="dayscell" key={i} flex={celWidth[i]}>
              {date[i]}
          </Col>,
      );
  }

  return <Row className="daysrow">{days}</Row>;
};

export interface CellProps {
  currentMonth: Moment;
  schedules: ScheduleListDto[];
  type: string;
  onClickItem: (item: DailyScheduleDto)  => void;
  makePopupContent: (item: DailyScheduleDto)  => void; 
}
const RenderCells = ({ currentMonth, schedules, type, onClickItem, makePopupContent}:CellProps) => {
  const monthStart = moment(currentMonth).startOf('month');
  const monthEnd = moment(monthStart).endOf('month');
  const startDate = moment(monthStart).startOf('week');
  const endDate = moment(monthEnd).endOf('week');

  const rows:any[] = [];
  let days:any[] = [];
  let day = startDate;
  let formattedDate = '';

  const celWidth = ['14%', '14.4%', '14.4%', '14%.4', '14%.4', '14%.4', '14%'];
  while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
          formattedDate = moment(day).format('D');
          const idx = Number(formattedDate)-1;
          if (!!schedules && schedules.length > idx  && monthStart <= day && monthEnd >= day) {
            days.push(
              <Col className={'cellLayout'} key={formattedDate} flex={celWidth[i]}>
                {formattedDate}
                <ul>      
                  {schedules[idx].schedules?.map((item) => {
                  return (
                    <li key={item.id} className='schedule' >
                      <Popover 
                        placement="rightTop" 
                        content={makePopupContent(item)}
                      >
                        <a onClick={()=> onClickItem(item)}>
                          {(type==='op')?(
                            <>
                              <span className={'lecture_status_type_' + item.lecture_status_type}>●</span> <span>{item.start_time} {item.operator} {item.project_type==='b2b'&&('['+item.company_name+'] ')} {item.project_title}</span>
                            </>
                          ):(
                            <>
                              <span className={'lecture_status_type_' + item.lecture_status_type}>●</span> <span className={'lecture_place_type_' + item.lecture_place_type}>{item.start_time} {item.lecturer_name} {item.project_title}</span>
                            </>
                          )}
                          
                        </a>
                      </Popover>
                    </li>                   
                  )    
                  })}                  
                </ul>
              </Col>
            );
          } else {
            days.push(
              <Col className={'cellLayout'} key={formattedDate} flex={celWidth[i]}>
                {formattedDate}
              </Col>
            );
          }

          day = moment(day).add(1, 'day');
      }
      rows.push(
          <Row className={'rowLayout my-calender'} key={day.format('YYYYMMDD')}>
              {days}
          </Row>,
      );
      days = [];
  }
  return <div className="cellbody">{rows}</div>;
};

export interface CalenderProps {
  current: string;
  schedules: ScheduleListDto[];
  type: string;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onExcelDownload: () => void;
  onClickItem: (item: DailyScheduleDto)  => void;
  makePopupContent: (item: DailyScheduleDto)  => void;  
}

const Calender = ({current, schedules, type, onPrevMonth, onNextMonth, onClickItem, makePopupContent, onExcelDownload}: CalenderProps): React.ReactElement => {

  const [currentMonth, setCurrentMonth] = useState(moment());  

  useEffect(() => {
    if (current)
    setCurrentMonth(moment(current))
  }, [current])

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div>
      <div className='schedule_info'>
        {(type==='op')?(
          <>
            <span className={'lecture_status_type_1'}>●</span>&nbsp;<span>완료</span>&nbsp;&nbsp;&nbsp;
            <span className={'lecture_status_type_3'}>●</span>&nbsp;<span>확정</span>&nbsp;&nbsp;&nbsp;
            <span className={'lecture_status_type_2'}>●</span>&nbsp;<span>미배정</span>&nbsp;&nbsp;&nbsp;
          </>
        ):(
          <>
            <span className={'lecture_status_type_1'}>●</span>&nbsp;<span>완료</span>&nbsp;&nbsp;&nbsp;
            <span className={'lecture_status_type_2'}>●</span>&nbsp;<span>평가 미입력</span>&nbsp;&nbsp;&nbsp;
            <span className={'lecture_status_type_3'}>●</span>&nbsp;<span>확정</span>&nbsp;&nbsp;&nbsp;
            <span className='lecture_place_type_ONLINE'>온라인</span>&nbsp;&nbsp;&nbsp;
            <span className='lecture_place_type_OFFLINE'>오프라인</span>&nbsp;&nbsp;&nbsp;          
          </>
        )}
        <Button size='small' icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
      </div>
      <RenderHeader currentMonth={currentMonth} prevMonth={onPrevMonth} nextMonth={onNextMonth}/>
      <RenderDays />
      <RenderCells 
          currentMonth={currentMonth}
          schedules={schedules}
          type={type}
          onClickItem={onClickItem}
          makePopupContent={makePopupContent}
      />
    </div>
  );
};

export default React.memo(Calender);
